import { createSelector } from '@ngrx/store';
import { CAAction } from '../actions';
import { State } from '../reducers/index';
import { DataListState, INITIAL_DATA_LIST_STATE } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';
import { Tenants } from './tenants.actions';
import { TenantDto } from '@careapp-group/ng-sdk-v2-new';

class TenantsState extends ReducerStateFactory<TenantDto> {
  readonly initialState: DataListState<TenantDto> = INITIAL_DATA_LIST_STATE;

  constructor(actions) {
    super(actions);
  }

  public reducer(state = this.initialState, action: CAAction | any): DataListState<TenantDto> {
    switch (action.type) {
      default:
        return <any>super.reducer(state, action);
    }
  }
}

export const state = new TenantsState(Tenants);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}

export const createSelectors = (rootReducer) => ({
  getTenants: createSelector(rootReducer, (rootState: State) => rootState.tenants),
});
